import styles from './Checkbox.module.scss';

import React from 'react';

type CheckboxProps = {
  isChecked: boolean;
  disabled?: boolean;
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const Checkbox: React.FC<CheckboxProps> = ({
  isChecked,
  disabled,
  onClick
}) => (
  <div className={styles.checkbox}>
    <input
      type="checkbox"
      checked={isChecked}
      onClick={onClick}
      disabled={disabled}
    />
  </div>
);

export default Checkbox;
